/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckSquareCutIcon24Solid = forwardRef('CheckSquareCutIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M6.5 2A4.5 4.5 0 0 0 2 6.5v11A4.5 4.5 0 0 0 6.5 22h11a4.5 4.5 0 0 0 4.5-4.5V6.722l-8.353 8.353a3.125 3.125 0 0 1-4.42 0L6.242 12.09A1.25 1.25 0 1 1 8.01 10.32l2.987 2.986c.244.245.64.245.883 0l9.34-9.34A4.495 4.495 0 0 0 17.5 2h-11Z" })));
});
